import { render, staticRenderFns } from "./ph-product-list.vue?vue&type=template&id=75616b40&scoped=true"
import script from "./ph-product-list.vue?vue&type=script&lang=js"
export * from "./ph-product-list.vue?vue&type=script&lang=js"
import style0 from "./ph-product-list.vue?vue&type=style&index=0&id=75616b40&prod&scoped=true&lang=css"
import style1 from "./ph-product-list.vue?vue&type=style&index=1&id=75616b40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75616b40",
  null
  
)

export default component.exports